import { useMutation } from "react-query";
import { POST } from "../../Services";
import { notification } from "antd";

// ============= HOOKS DE ELIMINACIÓN =============

// Pokemon
export const useEliminarPokemon = () => {
  return useMutation(
    async (data) => await POST(data, "pokemon/eliminarPokemon"),
    {
      onSuccess: () => {
        notification["success"]({ 
          message: "Pokémon eliminado correctamente",
          description: "El Pokémon ha sido eliminado del sistema"
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({ 
            message: "Error al eliminar Pokémon",
            description: "No se pudo eliminar el Pokémon. Intente nuevamente"
          });
        }
      },
    }
  );
};

// Logros
export const useEliminarLogro = () => {
  return useMutation(
    async (data) => await POST(data, "logros/eliminarLogro"),
    {
      onSuccess: () => {
        notification["success"]({ 
          message: "Logro eliminado correctamente",
          description: "El logro ha sido eliminado del sistema"
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({ 
            message: "Error al eliminar logro",
            description: "No se pudo eliminar el logro. Intente nuevamente"
          });
        }
      },
    }
  );
};

// Requerimiento Evolución
export const useEliminarRequerimientoEvolucion = () => {
  return useMutation(
    async (data) => await POST(data, "requerimientosEvolucion/eliminarRequerimientoEvolucion"),
    {
      onSuccess: () => {
        notification["success"]({ 
          message: "Requerimiento de evolución eliminado correctamente",
          description: "El requerimiento de evolución ha sido eliminado del sistema"
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({ 
            message: "Error al eliminar requerimiento de evolución",
            description: "No se pudo eliminar el requerimiento. Intente nuevamente"
          });
        }
      },
    }
  );
};

// Zonas
export const useEliminarZona = () => {
  return useMutation(
    async (data) => await POST(data, "zonas/eliminarZona"),
    {
      onSuccess: () => {
        notification["success"]({ 
          message: "Zona eliminada correctamente",
          description: "La zona ha sido eliminada del sistema"
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({ 
            message: "Error al eliminar zona",
            description: "No se pudo eliminar la zona. Intente nuevamente"
          });
        }
      },
    }
  );
};

// Objetos
export const useEliminarObjeto = () => {
  return useMutation(
    async (data) => await POST(data, "objeto/eliminarObjeto"),
    {
      onSuccess: () => {
        notification["success"]({ 
          message: "Objeto eliminado correctamente",
          description: "El objeto ha sido eliminado del sistema"
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({ 
            message: "Error al eliminar objeto",
            description: "No se pudo eliminar el objeto. Intente nuevamente"
          });
        }
      },
    }
  );
};

// Tipo Imagen
export const useEliminarTipoImagen = () => {
  return useMutation(
    async (data) => await POST(data, "tipoImagen/eliminarTipoImagen"),
    {
      onSuccess: () => {
        notification["success"]({ 
          message: "Tipo de imagen eliminado correctamente",
          description: "El tipo de imagen ha sido eliminado del sistema"
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({ 
            message: "Error al eliminar tipo de imagen",
            description: "No se pudo eliminar el tipo de imagen. Intente nuevamente"
          });
        }
      },
    }
  );
};

// Roles
export const useEliminarRol = () => {
  return useMutation(
    async (data) => await POST(data, "rol/eliminarRol"),
    {
      onSuccess: () => {
        notification["success"]({ 
          message: "Rol eliminado correctamente",
          description: "El rol ha sido eliminado del sistema"
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({ 
            message: "Error al eliminar rol",
            description: "No se pudo eliminar el rol. Intente nuevamente"
          });
        }
      },
    }
  );
};

// Gachapon (ya existe pero lo incluyo para completar)
export const useEliminarGachapon = () => {
  return useMutation(
    async (data) => await POST(data, "gachapon/eliminarGachapon"),
    {
      onSuccess: () => {
        notification["success"]({ 
          message: "Gachapon eliminado correctamente",
          description: "El gachapon ha sido eliminado del sistema"
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({ 
            message: "Error al eliminar gachapon",
            description: "No se pudo eliminar el gachapon. Intente nuevamente"
          });
        }
      },
    }
  );
};

export const useLiberarPokemon = () => {
  return useMutation(
    async (data) => await POST(data, "pokemon/eliminarPokemonObtenido"),
    {
      onSuccess: () => {
        notification["success"]({ 
          message: "Pokemon liberado correctamente",
          description: "El Pokemon ha sido liberado del sistema"
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({ 
            message: "Error al eliminar gachapon",
            description: "No se pudo eliminar el gachapon. Intente nuevamente"
          });
        }
      },
    }
  );
};

// Permisos
export const useEliminarPermiso = () => {
  return useMutation(
    async (data) => await POST(data, "permiso/eliminarPermiso"),
    {
      onSuccess: () => {
        notification["success"]({
          message: "Permiso eliminado correctamente",
          description: "El permiso ha sido eliminado del sistema"
        });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({
            message: "Error al eliminar permiso",
            description: "No se pudo eliminar el permiso. Intente nuevamente"
          });
        }
      },
    }
  );
};
